import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { BbChartsModule } from './bb-charts/bb-charts.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SbTranslateLoader } from './locale/sb-translate-loader';
import { HttpClient } from '@angular/common/http';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { KeyMetricsComponent } from './components/key-metrics/key-metrics.component';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MetricContainerComponent } from './components/metrics/metric-container.component';
import { MetricComponent } from './components/metrics/metric.component';
import { MetricComponent as KeyMetricComponent } from './components/key-metrics/metric/metric.component';
import {
    MatLegacyAutocomplete as MatAutocomplete,
    MatLegacyAutocompleteModule as MatAutocompleteModule
} from '@angular/material/legacy-autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { SbPillsComponent } from './components/sb-pills/sb-pills.component';
import { CamelToSentenceCasePipe } from './pipes/camel-to-sentence-case.pipe';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { AbsolutePipe, DecoratePipe, NumeralPipe, TranslateEnumPipe } from './pipes';
import { NaDecimalPipe } from './pipes/na-decimal.pipe';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { DynamicPipe } from './pipes/dynamic.pipe';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { SbToastComponent } from './services/toast/sb-toast.component';
import { AppConfigQuery } from '../core/state/app-config/app-config.query';
import { SbModalComponent } from './components/sb-modal/sb-modal.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { FormattedNumberPipe } from './pipes/formatted-number.pipe';
import { FormattedPercentPipe } from './pipes/formatted-percent.pipe';
import { SbPendingButtonIndicatorComponent } from './components/sb-pending-button-indicator/sb-pending-button-indicator.component';
import { SbFormatInputNumberDirective } from './directives/sb-format-input-number.directive';
import { FormatCurrencyPipe } from './pipes/format-currency.pipe';
import { SbFileUploadAreaComponent } from './components/sb-file-upload-area/sb-file-upload-area.component';
import { StrictTitleCasePipe } from './pipes/strict-title-case.pipe';
import { SbPerformanceChartComponent } from './components/sb-performance-chart/sb-performance-chart.component';
import { CurrencySelectorComponent } from './components/currency-selector/currency-selector.component';
import { CurrencyCountryDecoratorPipe } from './components/currency-selector/currency-country-decorator-pipe';
import { AccountsSelectorComponent } from './components/accounts-selector/accounts-selector.component';
import { TransactionDatesComponent } from './components/transaction-dates/transaction-dates.component';
import { SbViewInstrumentComponent } from './components/modal/sb-view-instrument/sb-view-instrument.component';
import { SbHistoryComponent } from './components/sb-history/sb-history.component';
import { IconsModule } from './icons/icons.module';
import { SbKeyMetricListComponent } from './components/sb-key-metric-list/sb-key-metric-list.component';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { SbModalHeaderComponent } from './components/modal/sb-modal-header/sb-modal-header.component';
import { SbModalBodyComponent } from './components/modal/sb-modal-body/sb-modal-body.component';
import { SbModalFooterComponent } from './components/modal/sb-modal-footer/sb-modal-footer.component';
import { SbDualListboxComponent } from './components/dual-listbox/dual-listbox.component';
import { FormatRoleNamePipe } from './pipes/format-role-name.pipe';
import { SbCardSectionComponent } from './components/card-section/sb-card-section.component';
import { SbMarketValueOverTimeChartComponent } from './components/sb-market-value-over-time-chart-component/sb-market-value-over-time-chart.component';
import { SbPrintButtonsComponent } from './components/sb-print-buttons/sb-print-buttons.component';
import { HighlightPipe } from './pipes/highlight.pipe';
import { InstrumentDisplayNamePipe } from './state/instruments/instrument-display-name.pipe';
import { TableModule } from './table/table/table.module';
@NgModule({
    declarations: [
        KeyMetricsComponent,
        MetricContainerComponent,
        MetricComponent,
        NumeralPipe,
        AbsolutePipe,
        KeyMetricComponent,
        TranslateEnumPipe,
        DecoratePipe,
        NaDecimalPipe,
        DynamicPipe,
        SbToastComponent,
        SbPerformanceChartComponent,
        CurrencySelectorComponent,
        SbHistoryComponent,
        SbDualListboxComponent,
        SbCardSectionComponent,
        SbDualListboxComponent,
        SbMarketValueOverTimeChartComponent,
        SbPrintButtonsComponent
    ],
    imports: [
        MatIconModule,
        CommonModule,
        RouterModule,
        BbChartsModule,
        TranslateModule.forRoot({
            defaultLanguage: 'en',
            loader: {
                provide: TranslateLoader,
                useClass: SbTranslateLoader,
                deps: [HttpClient, AppConfigQuery]
            }
        }),
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatListModule,
        MatButtonModule,
        MatSelectModule,
        DragDropModule,
        MatAutocompleteModule,
        FormsModule,
        ReactiveFormsModule,
        MatTabsModule,
        MatRadioModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatSnackBarModule,
        NgxSliderModule,
        IconsModule,
        FormattedNumberPipe,
        FormattedPercentPipe,
        SbModalComponent,
        SbModalHeaderComponent,
        SbModalBodyComponent,
        SbModalFooterComponent,
        SbPendingButtonIndicatorComponent,
        SbFormatInputNumberDirective,
        AccountsSelectorComponent,
        TransactionDatesComponent,
        SbPillsComponent,
        SbKeyMetricListComponent,
        SbViewInstrumentComponent,
        SbFileUploadAreaComponent,
        StrictTitleCasePipe,
        FormatRoleNamePipe,
        FormatCurrencyPipe,
        InstrumentDisplayNamePipe,
        TableModule,
        HighlightPipe
    ],
    exports: [
        RouterModule,
        MatIconModule,
        BbChartsModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        KeyMetricsComponent,
        TableModule,
        MatSelectModule,
        AbsolutePipe,
        NumeralPipe,
        MetricContainerComponent,
        MetricComponent,
        KeyMetricComponent,
        MatAutocomplete,
        MatAutocompleteModule,
        FormsModule,
        ReactiveFormsModule,
        MatTabsModule,
        SbPillsComponent,
        TranslateEnumPipe,
        DecoratePipe,
        NaDecimalPipe,
        MatCheckboxModule,
        MatRadioModule,
        DynamicPipe,
        SbToastComponent,
        MatSnackBarModule,
        SbModalComponent,
        NgxSliderModule,
        FormattedNumberPipe,
        FormattedPercentPipe,
        SbPendingButtonIndicatorComponent,
        SbFormatInputNumberDirective,
        SbPendingButtonIndicatorComponent,
        SbFileUploadAreaComponent,
        SbPerformanceChartComponent,
        CurrencySelectorComponent,
        AccountsSelectorComponent,
        TransactionDatesComponent,
        SbViewInstrumentComponent,
        SbKeyMetricListComponent,
        SbModalHeaderComponent,
        SbModalBodyComponent,
        SbModalFooterComponent,
        SbPendingButtonIndicatorComponent,
        SbDualListboxComponent,
        StrictTitleCasePipe,
        FormatRoleNamePipe,
        SbCardSectionComponent,
        StrictTitleCasePipe,
        SbMarketValueOverTimeChartComponent,
        SbPrintButtonsComponent,
        InstrumentDisplayNamePipe,
        HighlightPipe
    ],
    providers: [
        FormattedNumberPipe,
        FormattedPercentPipe,
        FormatCurrencyPipe,
        NaDecimalPipe,
        StrictTitleCasePipe,
        FormatRoleNamePipe,
        CamelToSentenceCasePipe,
        CurrencyCountryDecoratorPipe
    ]
})
export class SharedModule {}
